<template>
  <div class="auctionInfo ant-layout">
    <h2 class="intro-y text-lg font-medium mt-10">一键转至360pai进行租赁权拍卖</h2>
    <div class="grid grid-cols-12 gap-6 mt-5">
      <div
          class="intro-y col-span-12 flex flex-wrap sm:flex-no-wrap items-center mt-2"
      >
        <button class="button text-white bg-theme-1 shadow-md mr-2"
                @click='$router.push({path:"/assetManagement/assetDetail",query:{ assetId :  form.assetId}})'>
          返回
        </button>
      </div>
    </div>
    <div class="intro-y box py-10 sm:py-20 mt-5">
      <div
          class="wizard flex flex-col lg:flex-row justify-center px-5 sm:px-20"
      >
        <div
            class="intro-x lg:text-center flex items-center lg:block flex-1 z-10"
        >
          <button class="w-10 h-10 rounded-full button text-gray-600 bg-gray-200 dark:bg-dark-1">
            1
          </button>
          <div class="lg:w-32 font-medium text-base lg:mt-3 ml-3 lg:mx-auto">
            生成招商公告
          </div>
        </div>

        <div
            class="intro-x lg:text-center flex items-center mt-5 lg:mt-0 lg:block flex-1 z-10"
        >
          <button
              class="w-10 h-10 rounded-full button text-white bg-theme-1"
          >
            2
          </button>
          <div
              class="lg:w-32 text-base lg:mt-3 ml-3 lg:mx-auto text-gray-700 dark:text-gray-600"
          >
            填写拍卖信息
          </div>
        </div>
        <div
            class="intro-x lg:text-center flex items-center mt-5 lg:mt-0 lg:block flex-1 z-10"
        >
          <button
              class="w-10 h-10 rounded-full button text-gray-600 bg-gray-200 dark:bg-dark-1"

          >
            3
          </button>
          <div
              class="lg:w-32 text-base lg:mt-3 ml-3 lg:mx-auto text-gray-700 dark:text-gray-600"
          >
            完成
          </div>
        </div>
        <div
            class="wizard__line hidden lg:block w-1/2 bg-gray-200 dark:bg-dark-1 absolute mt-5"
        ></div>
      </div>
      <div class="px-5 sm:px-20 mt-10 pt-10 border-t border-gray-200 dark:border-dark-5">
        <el-form
            ref="ruleForm"
            :model="form"
            layout='horizontal'
            :rules="rules"
            style='width: 100%;'
        >
          <el-row :span='24'>
            <el-col :span='11' :offset='1'>
              <el-form-item label="选择拍卖方式: " style='position: relative' prop="expectedMode">
                <el-select v-model="form.expectedMode" style='width: 100%;' placeholder="请选择选择拍卖方式" clearable>
                  <el-option :label="item.name" :value="item.id" v-for="(item,index) in expectedModeOptions"
                             :key='item.id'>
                    {{ item.name }}
                  </el-option>
                </el-select>
                <a href="https://www.360pai.com/help/problem"
                   class='right-link'
                   target="_blank">了解拍卖方式
                </a>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="保留价: " prop="reservePrice">
                <el-col>
                  <el-input v-model="form.reservePrice" placeholder="请输入保留价" clearable style='width: 60%'/>
                  <el-select v-model="unitFlag" style='width: 35%;margin-left: 5%;'>
                    <el-option :label="item.name"
                               :value="item.id"
                               v-for="(item,index) in unitOptions"
                               :key='item.id'>
                      {{ item.name }}
                    </el-option>
                  </el-select>
                </el-col>
                <div class="right-money">
                  {{ reservePriceUnitChange }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="起拍价: " prop="startingPrice"
                            v-if='form.expectedMode=="ENGLISH"||form.expectedMode=="DUTCH"'>
                <el-col>
                  <el-input v-model="form.startingPrice" placeholder="请输入起拍价" clearable style='width: 60%'/>
                  <el-select v-model="unitFlag" style='width: 35%;margin-left: 5%;'>
                    <el-option :label="item.name"
                               :value="item.id"
                               v-for="(item,index) in unitOptions"
                               :key='item.id'>
                      {{ item.name }}
                    </el-option>
                  </el-select>
                </el-col>
                <div class="right-money">
                  {{ startingPriceUnitChange }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="加价幅度价: " prop="increment" v-if='form.expectedMode=="ENGLISH"'>
                <el-input style='width: 100%;' v-model="form.increment" placeholder="请输入加价幅度价" clearable/>
                <div class="right-money">
                  元
                </div>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="减价幅度: " prop="reduction" v-if='form.expectedMode=="DUTCH"'>
                <el-input style='width: 100%;' v-model="form.reduction" placeholder="请输入减价幅度" clearable/>
                <div class="right-money">
                  元
                </div>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="减价周期: " prop="reductionPeriod" v-if='form.expectedMode=="DUTCH"'>
                <el-input style='width: 100%;' v-model="form.reductionPeriod" placeholder="请输入减价周期" clearable/>
                <div class="right-money">
                  分钟/次
                </div>
              </el-form-item>
            </el-col>
            <el-col>
              <el-col :span='11' :offset='1'>
                <el-form-item label="拍卖服务机构名称: ">
                  <el-input :value='form.serverAgencyName' disabled/>
                </el-form-item>
              </el-col>
              <el-col :span='11' :offset='1'>
                <el-form-item label="保证金: " prop="deposit">
                  <el-input v-model="form.deposit" style='width: 100%;' placeholder="请输入保证金" clearable/>
                  <div class="right-money">
                    元
                  </div>
                  <div style='white-space: nowrap'>
                    注：以起拍价计算，一个月租金是{{ form.startingPrice / 12|twoFilter }}元，两个月租金是{{
                      form.startingPrice / 6|twoFilter
                    }}元
                  </div>
                </el-form-item>
              </el-col>
            </el-col>
            <el-col>
              <el-col :span='11' :offset='1'>
                <el-form-item label="承租方租赁押金: " prop="leaseDepositType">
                  <el-col>
                    <el-radio v-model="form.leaseDepositType" :label="1"> 一个月租金(成交价/12)</el-radio>
                    <el-radio v-model="form.leaseDepositType" :label="2"> 自定义</el-radio>
                  </el-col>

                </el-form-item>
                <el-form-item prop="leaseDeposit" v-bind='formItemLayoutWithOutLabel' v-if='form.leaseDepositType==2'>
                  <el-input style='width: 100%;' v-model="form.leaseDeposit" placeholder="请选择承租方租赁押金" clearable/>
                  <div style='white-space: nowrap'>
                    注：以起拍价计算，一个月租金是{{ form.startingPrice / 12|twoFilter }}元，两个月租金是{{
                      form.startingPrice / 6|twoFilter
                    }}元
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span='11' :offset='1'>
                <el-form-item label="平台服务费金额: ">
                  <el-input value='平台服务费为首年首月租金*对应折扣率' disabled/>
                  <span class='right-link' target="_blank" @click='discountModal=true'>了解优惠折扣率
          </span>
                </el-form-item>
              </el-col>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="出租方平台服务费分摊比例: " prop="lessorCommissionRate">
                <el-input v-model="form.lessorCommissionRate" placeholder="请输入出租方平台服务费分摊比例" clearable/>
                <div class="right-money">
                  %
                </div>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="承租方平台服务费分摊比例: " prop="lessorCommissionRate">
                <el-input :value="lessorCommissionRate" placeholder="请输入承租方平台服务费分摊比例" disabled/>
                <div class="right-money">
                  %
                </div>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="公告开始时间: " prop='previewAt'>
                <el-date-picker
                    :value-format="dateFormat"
                    v-model="form.previewAt"
                    type="datetime"
                    clearable
                    placeholder="请选择公告开始时间"
                    style="width: 100%;"
                ></el-date-picker>
                <div class="right-money">
                  精确到时间点
                </div>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="报名截止时间: " prop='applyEndTime'>
                <el-date-picker
                    :value-format="dateFormat"
                    v-model="form.applyEndTime"
                    show-time
                    type="datetime"
                    clearable
                    placeholder="请选择报名截止时间"
                    style="width: 100%;"
                />
                <div class="right-money">
                  精确到时间点，公告时间至少7天
                </div>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="审核截止时间: " prop='approvalEndTime'>
                <el-date-picker
                    :value-format="dateFormat"
                    v-model='form.approvalEndTime'
                    show-time
                    type="datetime"
                    clearable
                    placeholder="请选择审核截止时间"
                    style="width: 100%;"
                />
                <div class="right-money">
                  精确到时间点，审核时间至少2天
                </div>
              </el-form-item>
            </el-col>
            <el-col :span='23' :offset='1'>
              <el-form-item label="拍卖起止时间: " prop="endAt">
                <el-col>
                  <el-date-picker
                      :value-format="dateFormat"
                      v-model='form.beginAt'
                      show-time
                      type="datetime"
                      disabled
                      placeholder="开始时间"
                      style="width:47.83333%;min-width: initial!important;"
                  />
                  <el-date-picker
                      :value-format="dateFormat"
                      v-model='form.endAt'
                      show-time
                      type="datetime"
                      clearable
                      placeholder="结束时间"
                      style="width:47.83333%;min-width: initial!important;margin-left: 4.16667%;"
                  />
                </el-col>
                <div class="right-money">
                  精确到时间点，拍卖时间至少1小时
                </div>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="线下签约时间: " prop="handoverDays">
                <el-input v-model="form.handoverDays" placeholder="请输入线下签约时间" clearable/>
                <div class="right-money">
                  天
                </div>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="支付时间: " prop="payDays">
                <el-input v-model="form.payDays" placeholder="请输入支付时间" clearable/>
                <div class="right-money">
                  天
                </div>
              </el-form-item>
            </el-col>

          </el-row>
        </el-form>
      </div>

      <div
          class="intro-y col-span-12 flex items-center justify-center sm:justify-end mt-5"
          style='padding-right: 5rem;'
      >
        <el-button @click='back'>
          返回
        </el-button>
        <el-button
            type="primary"
            @click='handleSubmit'
        >
          提交发布
        </el-button>
      </div>
    </div>


    <discountRate v-model='discountModal'/>
  </div>
</template>

<script>
import discountRate from "../../../../components/discountRate";
import {saveAuction} from "../../../../api/asset";
import {mapState} from 'vuex'

export default {
  name: "auctionInfo",
  components: {
    discountRate,
  },
  data() {
    let checkNumber = (rule, value, callback) => {
      let numberReg = /^[0-9]{1}\d*(\.\d{1,2})?$/
      if (numberReg.test(value)) {
        callback()
      } else {
        callback(new Error(rule.message));
      }
    };
    let checkInteger = (rule, value, callback) => {
      let integerReg = /^[1-9]\d*$/
      if (integerReg.test(value)) {
        callback()
      } else {
        callback(new Error(rule.message));
      }
    };
    let checkReta = (rule, value, callback) => {
      let retaReg = /^(\d|[1-9]\d|100)(\.\d{1,2})?$/
      if (retaReg.test(value)) {
        callback()
      } else {
        callback(new Error(rule.message));
      }
    };
    let checkTime = (rule, value, callback) => {
      if (value[0] && value[1]) {
        callback()
      } else {
        callback(new Error(rule.message));
      }
    };

    return {
      dateFormat:'yyyy-MM-dd HH:mm:ss',
      current: 1,
      labelCol: {span: 6, offset: 3},
      wrapperCol: {span: 8},
      formItemLayoutWithOutLabel: {
        wrapperCol: {
          span: 8, offset: 9
        },
      },
      discountModal: false,
      unitFlag: 1,
      rules: {
        expectedMode: [
          {required: true, message: '请选择选择拍卖方式', trigger: 'change'},
        ],
        reservePrice: [
          {required: true, message: '请输入正确的保留价（最多两位小数）', validator: checkNumber, trigger: 'blur'},
        ],
        startingPrice: [
          {required: true, message: '请输入正确的起拍价（最多两位小数）', validator: checkNumber, trigger: 'blur'},
        ],
        increment: [
          {required: true, message: '请输入加价幅度价（最多两位小数）', validator: checkNumber, trigger: 'blur'},
        ],
        reduction: [
          {required: true, message: '请输入减价幅度（最多两位小数）', validator: checkNumber, trigger: 'blur'},
        ],
        reductionPeriod: [
          {required: true, message: '请输入减价周期（大于零的整数）', validator: checkInteger, trigger: 'blur'},
        ],
        deposit: [
          {required: true, message: '请输入保证金（最多两位小数）', validator: checkNumber, trigger: 'blur'},
        ],
        leaseDeposit: [
          {required: true, message: '请选择承租方租赁押金（最多两位小数）', validator: checkNumber, trigger: 'blur'},
        ],
        lessorCommissionRate: [
          {required: true, message: '请输入正确的出租方平台服务费分摊比例(0-100最多两位小数)', validator: checkReta, trigger: 'blur'},
        ],
        leaseDepositType: [
          {required: true, message: '请选择承租方租赁押金', trigger: 'change'},
        ],
        previewAt: [
          {required: true, message: '请选择公告开始时间', trigger: 'change'},
        ],
        applyEndTime: [
          {required: true, message: '请选择报名截止时间', trigger: 'change'},
        ],
        approvalEndTime: [
          {required: true, message: '请选择审核截止时间', trigger: 'change'},
        ],
        endAt: [
          {required: true, message: '请选择拍卖起止时间', trigger: 'change'},
        ],
        handoverDays: [
          {required: true, message: '请输入线下签约时间(大于0的整数)', validator: checkInteger, trigger: 'blur'},
        ],
        payDays: [
          {required: true, message: '请输入支付时间(大于0的整数)', validator: checkInteger, trigger: 'blur'},
        ],


      },
    }
  },
  methods: {
    handleSubmit() {
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          let para = Object.assign({}, this.form)
          para.lesseeCommissionRate = 100 - para.lessorCommissionRate
          let areaArray = []
          for (let i = 0; i < para.areaArray.length; i++) {
            areaArray.push({
              provinceId: para.areaArray[i].value[0] || '',
              id: para.areaArray[i].value[1] || '',
              areaId: para.areaArray[i].value[2] || '',
              townId: para.areaArray[i].value[3] || '',
            })
          }
          para.areaArray = areaArray
          para.leaseStartTime = para.leaseTime[0] || ''
          para.leaseEndTime = para.leaseTime[1] || ''
          para.viewBeginTime = para.viewTime[0] || ''
          para.viewEndTime = para.viewTime[1] || ''
          para.stepStatus = '3'
          if (this.unitFlag != 1) {
            para.startingPrice = para.startingPrice * para.leaseArea * 365
            para.reservePrice = para.reservePrice * para.leaseArea * 365
          }
          saveAuction(para).then(res => {
            let data = res.data
            if (data.code === '000') {
              this.$store.dispatch('resetAuction')
              this.$router.push({path: '/assetManagement/auctionSuccess', query: {assetId: para.assetId}})
            } else if (data.code == 1) {
              const h = this.$createElement;
              this.$msgbox({
                title: '温馨提示',
                message: h('p', null, [
                  h('span', {style: 'color: red'}, '未在360pai中找到对应的公司信息'),
                  h('span', null, '，请先在360pai注册该企业。 '),
                ]),
                showCancelButton: true,
                confirmButtonText: '前往360pai',
                cancelButtonText: '取消',
              }).then(action => {
                window.open('https://www.360pai.com/member/profile')
              });
            } else if (data.code == 2) {
              const h = this.$createElement;
              this.$msgbox({
                title: '温馨提示',
                message: h('p', null, [
                  h('span', {style: 'color: red'}, '未在360pai该公司下找到对应的企业经办人'),
                  h('span', null, '，请联系400-015-0005新增经办人。 '),
                ]),
                showCancelButton: true,
                confirmButtonText: '前往360pai',
                cancelButtonText: '取消',
              }).then(action => {
                window.open('https://www.360pai.com/member/profile')
              });
            } else {
              this.$message.error(data.desc)
            }
          }).catch(err => {
            console.log(err);
          }).finally(() => {

          })


        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    back() {
      this.$router.push({path: '/assetManagement/assetDetail', query: {assetId: this.form.assetId,}})
    },

  },
  created() {
  },
  computed: {
    ...mapState({
      expectedModeOptions: state => state.public.expectedModeOptions,
      unitOptions: state => state.public.unitOptions,
      // dateFormat: state => state.public.dateFormat,
      form: state => state.auction.form,
    }),
    //保留价单位转换
    reservePriceUnitChange() {
      if (this.form.reservePrice && this.form.leaseArea) {
        if (this.unitFlag == 1) {
          return (this.form.reservePrice / 365 / this.form.leaseArea).toFixed(2) + '元/平米/日'
        } else {
          return this.form.reservePrice * 365 * this.form.leaseArea + '元/年'
        }
      } else {
        if (this.unitFlag == 1) {
          return ''
        } else {
          return ''
        }
      }
    },
    //起拍价单位转换
    startingPriceUnitChange() {
      if (this.form.startingPrice && this.form.leaseArea) {
        if (this.unitFlag == 1) {
          return (this.form.startingPrice / 365 / this.form.leaseArea).toFixed(2) + '元/平米/日'
        } else {
          return this.form.startingPrice * 365 * this.form.leaseArea + '元/年'
        }
      } else {
        if (this.unitFlag == 1) {
          return ''
        } else {
          return ''
        }
      }
    },
    lessorCommissionRate() {
      if (this.form.lessorCommissionRate == '') {
        return ''
      }
      let retaReg = /^(\d|[1-9]\d|100)(\.\d{1,2})?$/
      if (retaReg.test(this.form.lessorCommissionRate)) {
        this.lesseeCommissionRate = 100 - this.form.lessorCommissionRate
        return 100 - this.form.lessorCommissionRate
      } else {
        return ''
      }
    },
  },
  filters: {
    twoFilter: function (value) {
      return value.toFixed(2)
    }
  },
  watch: {
    'form.approvalEndTime': function () {
      this.form.beginAt = this.form.approvalEndTime
    }
  },
}
</script>
<style>
.auctionInfo .ant-calendar-picker {
  width: 100%;
}

#times .ant-calendar-picker {
  min-width: initial !important;
}
</style>
<style scoped lang="scss">
.auctionInfo {


  .right-link {
    text-decoration: underline;
    color: #1d4299;
    font-size: 16px;
    padding-left: 20px;
    white-space: nowrap;
    cursor: pointer;
    position: absolute;
    right: 0;
    top: 0;
  }

  .right-money {
    color: #333;
    font-size: 14px;
    padding-left: 20px;
    white-space: nowrap;
    cursor: pointer;
    position: absolute;
    right: 0;
    top: 0;
  }

  .unit {
    position: absolute;
    bottom: 12px;
    right: -20px;
    line-height: 1;
    white-space: nowrap;
  }
}

h3 {
  font-size: 30px;
  font-weight: 700;
  margin: 20px 0;
  text-align: center;
}

</style>
